import React, { useState } from "react";
import "../css/dashboard.css";
import Header from "../components/header";
import Card from "../components/card";
import { Link } from "react-router-dom";
import { CardList } from "../Data/featureData";
import { MdSend } from "react-icons/md";
import ChatPopup from "../components/AIChatpopup";
import icon from "../img/OptionIconWhite.png";

function Dashboard() {
  // Stato per gestire l'apertura della chat full screen
  const [chatOpen, setChatOpen] = useState(false);
  // Stato per il testo digitato nella textarea
  const [inputMessage, setInputMessage] = useState("");

  const handleInputChange = (e) => {
    setInputMessage(e.target.value);
  };

  // Utility: mappa i messaggi salvati in sessionStorage nel formato richiesto dall'API
  const buildHistory = (msgs = []) =>
    msgs
      .filter(
        (m) =>
          m &&
          typeof m.text === "string" &&
          m.text.trim() !== "" &&
          m.text !== "Assistant is typing..."
      )
      .map((m) => ({
        role: m.sender === "user" ? "user" : "assistant",
        content: m.text,
      }));

  // Invia subito il messaggio e apre il popup,
  // poi esegue la chiamata API in background per aggiornare la cronologia
  const handleSendMessage = async () => {
    if (inputMessage.trim() === "") return;

    // Recupera i messaggi già salvati (se esistono)
    let messages = [];
    const storedMessages = sessionStorage.getItem("chatMessages");
    if (storedMessages) {
      try {
        messages = JSON.parse(storedMessages);
      } catch {
        messages = [];
      }
    }

    // Aggiungi il messaggio dell'utente e l'indicatore "Assistant is typing..."
    messages.push({ sender: "user", text: inputMessage });
    messages.push({ sender: "assistant", text: "Assistant is typing..." });
    sessionStorage.setItem("chatMessages", JSON.stringify(messages));

    // Pulisci il campo di input e apri il popup immediatamente
    const currentInput = inputMessage;
    setInputMessage("");
    setChatOpen(true);

    // Effettua la chiamata API in background per aggiornare la chat
    try {
      // Ricostruisci i messaggi aggiornati dal sessionStorage
      let updatedForHistory = [];
      const nowStored = sessionStorage.getItem("chatMessages");
      if (nowStored) {
        try {
          updatedForHistory = JSON.parse(nowStored);
        } catch {
          updatedForHistory = messages;
        }
      } else {
        updatedForHistory = messages;
      }

      // Costruisci l'history (filtrando il placeholder "typing")
      const historyPayload = buildHistory(updatedForHistory);

      const response = await fetch("https://adapt-flask-ep.com/adapt/ws.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        // <- nuova payload secondo la tua API
        body: JSON.stringify({
          serviceName: "chatbot_SM",
          history: historyPayload,
          message: currentInput,
          stream: false,
        }),
      });

      // Prova a leggere comunque il JSON della risposta
      const responseData = await response.json().catch(() => null);
      if (!response.ok) {
        throw new Error(
          `HTTP ${response.status}: ${responseData?.reason || "Request failed"}`
        );
      }

      // Estrai il testo dal payload che hai mostrato nel curl
      const botText =
        responseData?.output?.message ??
        responseData?.output ??
        responseData?.message ??
        responseData?.reply ??
        (typeof responseData === "string"
          ? responseData
          : JSON.stringify(responseData));

      const assistantMessage = {
        sender: "assistant",
        text: typeof botText === "string" ? botText : JSON.stringify(botText),
      };

      // Rimuove l'indicatore "Assistant is typing..." (se presente) e aggiunge la risposta definitiva
      let updatedMessagesRaw = sessionStorage.getItem("chatMessages");
      let updatedMessages = [];
      if (updatedMessagesRaw) {
        try {
          updatedMessages = JSON.parse(updatedMessagesRaw);
        } catch {
          updatedMessages = messages;
        }
      } else {
        updatedMessages = messages;
      }

      if (
        updatedMessages.length &&
        updatedMessages[updatedMessages.length - 1].text ===
          "Assistant is typing..."
      ) {
        updatedMessages.pop();
      }
      updatedMessages.push(assistantMessage);
      sessionStorage.setItem("chatMessages", JSON.stringify(updatedMessages));
    } catch (error) {
      console.error("Error sending message:", error);
      let updatedMessagesRaw = sessionStorage.getItem("chatMessages");
      let updatedMessages = [];
      if (updatedMessagesRaw) {
        try {
          updatedMessages = JSON.parse(updatedMessagesRaw);
        } catch {
          updatedMessages = messages;
        }
      } else {
        updatedMessages = messages;
      }

      if (
        updatedMessages.length &&
        updatedMessages[updatedMessages.length - 1].text ===
          "Assistant is typing..."
      ) {
        updatedMessages.pop();
      }
      updatedMessages.push({
        sender: "assistant",
        text:
          "Sorry, there was an error processing your request." +
          (error?.message ? ` (${error.message})` : ""),
      });
      sessionStorage.setItem("chatMessages", JSON.stringify(updatedMessages));
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  return (
    <>
      <Header />
      <div className="bodyclass">
        <h3 className="dashboardTitle titolo">FIND THE RIGHT TOOLS FOR YOU</h3>
        <div className="rigaDashboard">
          {CardList.map((card) => (
            <div className="colonna" key={card.id}>
              <Card
                url={card.url}
                id={card.id}
                icon={card.icon}
                name={card.name}
                description={card.description}
                classtype={card.classtype}
              />
            </div>
          ))}

          <div className="colonna" key={99999}>
            <div
              className="card"
              style={{ backgroundColor: "#1180ae" }}
            >
              <img src={icon} alt="icon" className="featureIcon" />
              <h5 className={`textlinkCard textlink`} style={{ color: "white" }}>More Tools Coming Soon</h5>
              <span
                className="textCard text" style={{ color: "white" }}
                dangerouslySetInnerHTML={{ __html: "Stay tuned for upcoming features and enhancements!" }}
              />
            </div>
          </div>

        </div>
        <div className="pipelineButtonDiv">
          <p className="textOrDashboard text">- or -</p>
          <Link className="textlink buttonDashboard button" to="/createpipeline">
            Create Your Pipeline
          </Link>
        </div>

        {/* Campo di input sempre visibile in basso */}
        <div className="riga">
          <div className="chat-body">
            <label>Welcome! Write your message here.</label>
            <div className="chat-input">
              <textarea
                placeholder="Write a message..."
                value={inputMessage}
                onChange={handleInputChange}
                onKeyDown={handleKeyPress}
              />
              <button className="button" onClick={handleSendMessage}>
                <MdSend size={25} />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Apertura della chat full screen */}
      {chatOpen && (
        <ChatPopup isOpen={chatOpen} onClose={() => setChatOpen(false)} />
      )}
    </>
  );
}

export default Dashboard;
